import { render } from "./Freezeframe.vue?vue&type=template&id=8aea883e"
import script from "./Freezeframe.vue?vue&type=script&lang=js"
export * from "./Freezeframe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__